(() => {
  function initialize() {
    document.querySelectorAll('.header__list .header-menu-trigger').forEach((trigger, index) => {
      if (trigger.dataset.one7Menu) return;
      const item = trigger.parentElement;
      const panel = trigger.nextElementSibling;
      if (!panel?.matches('.header__submenu, .header-mega-menu')) return;
      trigger.dataset.one7Menu = 'true';
      panel.id ||= `one7-menu-${index}`;
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-controls', panel.id);
      trigger.setAttribute('aria-expanded', 'false');
      item.dataset.one7MenuOpen = 'false';
      panel.inert = true;
      const setOpen = (open) => {
        item.dataset.one7MenuOpen = String(open);
        trigger.setAttribute('aria-expanded', String(open));
        panel.inert = !open;
        if (!open) {
          panel.querySelectorAll('[data-one7-menu-open]').forEach(child => {
            child.dataset.one7MenuOpen = 'false';
            child.querySelector('.header-menu-trigger')?.setAttribute('aria-expanded', 'false');
            const childPanel = child.querySelector('.header-menu-trigger')?.nextElementSibling;
            if (childPanel) childPanel.inert = true;
          });
        }
      };
      trigger.addEventListener('click', event => {
        event.preventDefault();
        setOpen(trigger.getAttribute('aria-expanded') !== 'true');
      });
      trigger.addEventListener('keydown', event => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          trigger.click();
        }
      });
      item.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || trigger.getAttribute('aria-expanded') !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        trigger.focus();
      });
      item.addEventListener('mouseenter', () => setOpen(true));
      item.addEventListener('mouseleave', () => {
        if (!item.contains(document.activeElement)) setOpen(false);
      });
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) setOpen(false);
      });
      document.addEventListener('click', event => {
        if (!item.contains(event.target)) setOpen(false);
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
